import { useThrottledCallback } from '@mantine/hooks';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { cleanupDataGridLocalStorageState } from '@/shared/ui/datagrid/hooks/state-storage/local-storage-state';

const CLEANUP_INTERVAL = 5 * 60 * 1000;

/** Mount once in App so navigation shares one throttle window. */
export const useDataGridStorageCleanup = () => {
  const location = useLocation();
  const cleanup = useThrottledCallback(
    cleanupDataGridLocalStorageState,
    CLEANUP_INTERVAL,
  );

  useEffect(() => {
    cleanup();
  }, [location, cleanup]);
};
